import { render, staticRenderFns } from "./headers.vue?vue&type=template&id=7a13c6a6&"
import script from "./headers.vue?vue&type=script&lang=ts&"
export * from "./headers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a13c6a6')) {
      api.createRecord('7a13c6a6', component.options)
    } else {
      api.reload('7a13c6a6', component.options)
    }
    module.hot.accept("./headers.vue?vue&type=template&id=7a13c6a6&", function () {
      api.rerender('7a13c6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/headers.vue"
export default component.exports